import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    this.element[this.identifier] = this;
    this.render();
  }

  initializeScriptTag(id) {
    if (!document.getElementById(id)) {
      let js = document.createElement('script');
      js.id = id;
      js.src = document.querySelector('meta[name=' + id + ']').getAttribute('value');
      document.head.appendChild(js);
    }
  }

  async render() {
    if (typeof window.HtmlDiff === 'undefined') {
      this.initializeScriptTag('htmldiff-js');
    }
    while (typeof window.HtmlDiff === 'undefined') {
      await new Promise(r => setTimeout(r, 100));
    }
    this.renderDiff();
  }

  renderDiff() {
    let v1 = this.element.querySelector('.mtf-diff-v1 > .diff');
    let v2 = this.element.querySelector('.mtf-diff-v2 > .diff');

    if (!v1 || !v2) {
      return;
    }

    let diff = window.HtmlDiff.execute(v2.innerHTML, v1.innerHTML);
    diff = diff.replace(/class=["']diff(mod|ins|del)["']/g, 'class="diffmod"');

    v1.innerHTML = diff.replace(/<del(.*?)<\/del>/gs, '').replace(/<\/ins>\s*<ins class="diffmod">/g, ' ');
    v2.innerHTML = diff.replace(/<ins(.*?)<\/ins>/gs, '').replace(/<\/del>\s*<del class="diffmod">/g, ' ');
  }
}
